import React, { useEffect, useState } from 'react';
import { Spin, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { userMangement } from '../../redux/actions/authActions';
import { RESEND_OTP_SUCCESS } from '../../constants/messages';

const SignUpTimer = ({ otpToken }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(90);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const resendOtp = () => {
    setLoading(true);
    dispatch(userMangement('pub.otp.resend', { otp_token: otpToken }))
      .then(() => {
        setLoading(false);
        message.success(RESEND_OTP_SUCCESS);
        setTimer(90);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Spin spinning={loading}>
      <div
        className="mt-20"
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="text-theme-color">
          {timer > 0
            ? `Time Remaining : ${moment.utc(timer * 1000).format('mm:ss')}`
            : `Didn't recieve code?`}
        </div>

        <Button
          type="link"
          disabled={timer > 0}
          className="clickhere"
          onClick={resendOtp}
        >
          Resend OTP
        </Button>
      </div>
    </Spin>
  );
};

export default SignUpTimer;
